import { Injectable } from '@angular/core';
import { DetachedRouteHandle } from '@angular/router';

/**
 * Holds detached route handles for tab reuse. Evict entries when a tab is closed
 * so the next visit loads a fresh component tree.
 */
@Injectable({ providedIn: 'root' })
export class TabRouteCacheRegistry {
    private readonly handles = new Map<string, DetachedRouteHandle>();

    has(key: string): boolean {
        return this.handles.has(key);
    }

    get(key: string): DetachedRouteHandle | undefined {
        return this.handles.get(key);
    }

    set(key: string, handle: DetachedRouteHandle): void {
        this.handles.set(key, handle);
    }

    delete(key: string): void {
        this.handles.delete(key);
    }

    clearAll(): void {
        this.handles.clear();
    }
}
